import { get } from 'lodash';
import React, { FC } from 'react';
import CreateTable from '../../../../../../components/ui-component/form-component/create-form/CreateTable';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
import { isTrue } from '../../../../../../utils/helper';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const Wissenschaftlische: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Aussagen zur erzielten Beschäftigungswikung' description={PLATZHALTER_TEXT} />
			<CreateTable
				formStruc={formStruc(application)}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
				columnsLabel={columnsLabel()}
			/>
		</>
	);
};
export default Wissenschaftlische;

const columnsLabel = () => {
	let labels = ['', 'Angabe', 'Anzahl'];
	return labels;
};
const formStruc = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					type: 'label',
					path: P.Wissenschaftliche_Arbeit_0259067749_ster_Bachelorarbeiten_Angabe.path,
				},
				{
					...P.Wissenschaftliche_Arbeit_0259067749_ster_Bachelorarbeiten_Angabe,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
				...(isTrue(get(application, P.Wissenschaftliche_Arbeit_0259067749_ster_Bachelorarbeiten_Angabe.path)) ?
					[P.Wissenschaftliche_Arbeit_0259120908_ster_Bachelorarbeiten_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Wissenschaftliche_Arbeit_0001270005_Arbeiten_Dissertation_Angabe.path,
				},
				{
					...P.Wissenschaftliche_Arbeit_0001270005_Arbeiten_Dissertation_Angabe,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
				...(isTrue(get(application, P.Wissenschaftliche_Arbeit_0001270005_Arbeiten_Dissertation_Angabe.path)) ?
					[P.Wissenschaftliche_Arbeit_0001290396_Arbeiten_Dissertation_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Wissenschaftliche_Arbeit_0023313381_et_Und_Fachhochschule_Angabe.path,
				},
				{
					...P.Wissenschaftliche_Arbeit_0023313381_et_Und_Fachhochschule_Angabe,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
				...(isTrue(get(application, P.Wissenschaftliche_Arbeit_0023313381_et_Und_Fachhochschule_Angabe.path)) ?
					[P.Wissenschaftliche_Arbeit_0023292812_et_Und_Fachhochschule_Anzahl]
				:	[]),
			],
		},
		{
			fields: [
				{
					type: 'label',
					path: P.Wissenschaftliche_Arbeit_0175143509_et_Und_Fachhochschule_Angabe.path,
				},
				{
					...P.Wissenschaftliche_Arbeit_0175143509_et_Und_Fachhochschule_Angabe,
					type: 'radio',
					validation: [{ validateFunction: NonRequired }],
				},
				...(isTrue(get(application, P.Wissenschaftliche_Arbeit_0175143509_et_Und_Fachhochschule_Angabe.path)) ?
					[P.Wissenschaftliche_Arbeit_0175286844_et_Und_Fachhochschule_Anzahl]
				:	[]),
			],
		},
	];

	return struc;
};

export const getFormStrucWissenschaftlische = (application: any) => {
	return formStruc(application);
};
